import http from 'utils/http';

export const getGeocode = (payload) => {
  return http.get('/utils/maps/geocode', payload);
};

export const checkFeatureToggle = (payload) => {
  return http.post('/utils/unleash-toggle-status', payload);
};
